function sessionStorageSave(name,value) {
    if (value != null) {
        sessionStorage.setItem(name,value);
    }
}

function sessionStorageRead(name) {
    if (sessionStorage.getItem(name) == "undefined") {
        return "";
    }
    return sessionStorage.getItem(name);
}

(function($) {

    $.PropertyFormSearch = function(element, options) {

        // PropertyFormSearch default options
        var defaults = {
            typeTransactionSelector             : '#typeTransaction',
            typeSelectSelector                  : '#typeSelect',
            locationSelector                    : '#location',
            inputReferenceSelector              : 'input[name="reference"]',
            alertContainerSelector              : '#alertContainer',
            moreOptionsBtnSelector              : '#moreOptionsBtn',
            advancedOptionsContainerSelector    : '#advancedOptionsContainer',
            advancedOptionsInputSelector        : '.type-dependant',
            moreOptionsBtnActivatedHtml         : '<i class="fa fa-minus"></i>',
            moreOptionsBtnUnactivatedHtml       : '<i class="fa fa-plus"></i>',
            classTypeDependantSelector          : '.type-dependant',
            skipLocationValidation              : false,
            skipLocationLoadFromCookie          : false,

            //optionnels
            onSubmit                            : null,
            typeBienCallback                    : null,
            locationCallback                    : null,

            optionsToStoreInSession               : [
                {
                    'jquerySelector':   "select[name='typeSelect[]']",
                    'cookieName':       "typeCookie",
                    'isSelect':         true,
                },
                {
                    'jquerySelector':   "input[name='budgetmin']",
                    'cookieName':       "budgetminCookie"
                },
                {
                    'jquerySelector':   "input[name='budgetmax']",
                    'cookieName':       "budgetmaxCookie"
                },
                {
                    'jquerySelector':   "input[name='surfaceMini']",
                    'cookieName':       "surfaceMiniCookie"
                },
                {
                    'jquerySelector':   "input[name='surfaceMax']",
                    'cookieName':       "surfaceMaxCookie"
                },
                {
                    'jquerySelector':   "input[name='terrainMini']",
                    'cookieName':       "terrainMiniCookie"
                },
                {
                    'jquerySelector':   "input[name='terrainMax']",
                    'cookieName':       "terrainMaxCookie"
                },
                {
                    'jquerySelector':   "input[name='terrainMini']",
                    'cookieName':       "terrainMiniCookie"
                },
                {
                    'jquerySelector':   "input[name='chargesMax']",
                    'cookieName':       "chargesMaxCookie"
                },
                {
                    'jquerySelector':   "input[name='charges']",
                    'cookieName':       "chargesMaxCookie"
                },
                {
                    'jquerySelector':   "select[name='pieces[]']",
                    'cookieName':       "roomNumbersCookie",
                    'isSelect':         true,
                },
                {
                    'jquerySelector':   "select[name='etages[]']",
                    'cookieName':       "floorNumbersCookie",
                    'isSelect':         true,
                },
                {
                    'jquerySelector':   "select[name='appartements[]']",
                    'cookieName':       "aptNumbersCookie",
                    'isSelect':         true,
                },
                {
                    'jquerySelector':   "select[name='chambres[]']",
                    'cookieName':       "bedroomNumbersCookie",
                    'isSelect':         true,
                },
                {
                    'jquerySelector':   "select[name='caracteristics[]']",
                    'cookieName':       "caracteristicsListCookie",
                    'isSelect':         true,
                },
                {
                    'jquerySelector':   "select[name='location-select[]']",
                    'cookieName':       "locationCookie",
                    'isSelect':         true,
                    'isLocation':       true
                }
            ]
        };

        // Private vars
        var plugin = this;
        plugin.settings = {};

        var $element = $(element),
            element = element;

        var hiddenLocationInputId = "location"+Math.random().toString(36).substring(4),
            typeSelectPreviouslySelectedValues  = [],
            availableTypeSelectForMoreOptions = [
                //classiques
                'appartement',
                'maison',
                'stationnement',
                'terrain',
                'immeuble',
                //prestiges
                'maison_villa',
                'demeure_charme',
                'manoir_chateau',
                'propriete',
                'immeuble_standing',
                'appartement_exception',

            ],
            ERR_SELECTION_PROPERTY = false,
            ERR_SELECTION_LOCATION = false;

        //Public methods
        plugin.init = function() {
            // the plugin's final properties are the merged default and
            // user-provided options (if any)
            plugin.settings = $.extend({}, defaults, options);
            setup();
        };

        //Private methods
        var setup = function(){

            clearErrorMessage();
            setupLocationInput();
            bindObservers();

            $(plugin.settings.typeTransactionSelector).trigger('change');

            var sessionOptions = plugin.settings.optionsToStoreInSession;
            for(var i in sessionOptions){
                var courant = sessionOptions[i];
                var jquerySelector = courant.jquerySelector;
                var cookieName = courant.cookieName;
                var cookieValue = sessionStorageRead(cookieName);
                if(cookieValue && cookieValue != 'null'){
                    if(courant.isLocation){
                        if(!plugin.settings.skipLocationLoadFromCookie){
                            $.ajax({
                                url: '/location-search',
                                type: 'GET',
                                data: {slugs: cookieValue.replace(new RegExp(',', 'g'), '_')}
                            }).done(function(_result) {
                                $(jquerySelector,$element).html('');
                                var location = "";
                                $.each(_result.items, function(key,item){
                                    if(item.slug && item.label){
                                        $(jquerySelector,$element).append('<option value="'+item.slug+'" selected="selected">'+item.label+'</option>');
                                        if(location){
                                            location = location+',';
                                        }
                                        location = location+item.slug;
                                    }
                                });
                                sessionStorageSave(cookieName, location);
                            });
                        }
                    }else{
                        if(courant.isSelect){
                            var arrayType = cookieValue.split(',');
                            for (var i = 0; i < arrayType.length; i++) {
                                var value = arrayType[i].toLowerCase();
                                $("option[value='"+value+"']",$(jquerySelector,$element)).attr('selected', 'selected');
                            }
                            $(jquerySelector,$element).trigger('change');
                        }else{
                            $(jquerySelector,$element).val(cookieValue);
                        }
                    }
                }
            };
        };

        var displayOnTopLocationSelect = function(){
            setTimeout(
                function(){
                    var parent = $(plugin.settings.locationSelector).parent();
                    $(".select2-selection__rendered",parent).scrollTop(0)
                },
                100
            );
        }

        var setupLocationInput = function(){
            var locationInput = $(plugin.settings.locationSelector);

            $(locationInput).hide();
            $(locationInput).select2({
                ajax: {
                    url: '/location-search',
                    type: 'GET',
                    dataType: 'json',
                    delay: 500,
                    data: function (params) {
                        return {
                            q: params.term, // search term
                            page: params.page,
                            page_limit: 30,
                        };
                    },
                    processResults: function (data, params) {
                        var results = [];
                        $.each(data.items,function(key,item){
                            if(item.slug && item.label){
                                results.push({
                                    id: item.slug,
                                    text: item.label
                                });
                            }
                        });

                        var size = data.totalCount;
                        var page = params.page;
                        if(!page){
                            page = 1;
                        }
                        var more = (page * 30) < size;
                        return {
                            results: results,
                            pagination: {
                                more: more
                            }
                        };
                    },
                },
                placeholder: 'Lieu',
                multiple:true,
                escapeMarkup: function (markup) {
                    return markup;
                },
                minimumInputLength: 2,
                width: 'style',
                dropdownAutoWidth : true
            });
        };

        var bindObservers = function(){

            $element.on('submit',function(event) {
                var transactionType = $(plugin.settings.typeTransactionSelector).val();
                var propertyTypes = $(plugin.settings.typeSelectSelector).val();
                var location = $(plugin.settings.locationSelector).val();
                var budget = $('input[name=budget]',$element).val();
                var reference = $(plugin.settings.inputReferenceSelector,$element).val();
                var hasError = false;

                /* Charly: Je commente cette partie car je ne sais pas d'ou ca sort et quel est l'idée*/
                if(propertyTypes === null && location === "" && budget === "") {
                    event.preventDefault();
                    window.location.href = $('.buy-rent-btns.'+transactionType).data('pageurl');
                    return false;
                }

                if(!reference){
                    if(propertyTypes === null) {//If no property type
                        showError("Veuillez saisir un ou plusieurs types de bien");
                        hasError = true;
                        ERR_SELECTION_PROPERTY = true;
                    }else if( !plugin.settings.skipLocationValidation
                                &&    ( !location
                                        ||  (location.length <= 0)
                                )
                            ) {//if no location

                        showError("Veuillez saisir une ou plusieurs localités");
                        hasError = true;
                        ERR_SELECTION_LOCATION= true;
                    }
                }


                if(plugin.settings.onSubmit){
                    hasError = plugin.settings.onSubmit(showError);
                }

                if(hasError) {
                    event.preventDefault();
                    return false;
                }

                var locationString = "";
                for(var i in location){
                    locationString += location[i];
                    if(i < (location.length -1) ){
                        locationString += "_";
                    }
                }

                var sessionOptions = plugin.settings.optionsToStoreInSession;
                for(var i in sessionOptions){
                    var courant = sessionOptions[i];
                    var jquerySelector = courant.jquerySelector;
                    var cookieName = courant.cookieName;
                    sessionStorageSave(cookieName, $(jquerySelector,$element).val());
                };

                $(plugin.settings.locationSelector).remove();
                $('#'+hiddenLocationInputId).remove();
                $element.append('<input id="'+hiddenLocationInputId+'" type="hidden" name="location" value="'+locationString+'" >');



            });

            $(plugin.settings.moreOptionsBtnSelector)
            .on('click',onClickOnMoreOptions);

            $(plugin.settings.typeTransactionSelector)
            .on('change',onChangeTypeTransaction);


            /* enable scrollTop after 100ms
            $(plugin.settings.locationSelector)
            .on('change',displayOnTopLocationSelect);
            */

            $(plugin.settings.typeSelectSelector).on('change',onChangeTypeSelect);

            //gestion des callback optionnelles
            if(plugin.settings.typeBienCallback){
                $(plugin.settings.typeSelectSelector).on('change',plugin.settings.typeBienCallback);
                $(plugin.settings.typeSelectSelector).trigger('change');
            }
            if(plugin.settings.locationCallback){
                $(plugin.settings.locationSelector).on('change',plugin.settings.locationCallback);
                $(plugin.settings.locationSelector).trigger('change');
            }
        };


        var onSelectLocation = function() {
            if(ERR_SELECTION_LOCATION){
                ERR_SELECTION_LOCATION = false;
                clearErrorMessage();
            }

            var idLocation = $(plugin.settings.locationSelector).attr('id');
        }


        var onClickOnMoreOptions = function(){
            var btn = $(plugin.settings.moreOptionsBtnSelector);
            btn.toggleClass('activated');
            if(btn.hasClass('activated')){
                btn.html(plugin.settings.moreOptionsBtnActivatedHtml);
                if(!isMoreOptionsAvailable()){
                    return handleMoreOptionsNotAvailable();
                }
            }else{
                btn.html(plugin.settings.moreOptionsBtnUnactivatedHtml);
                if(!ERR_SELECTION_PROPERTY && !ERR_SELECTION_LOCATION){
                    clearErrorMessage();
                }
            }

            handleMoreOptions();
        };

        var isMoreOptionsAvailable = function(){
            var typeSelectValues = $(plugin.settings.typeSelectSelector).val();
            if(!typeSelectValues || typeSelectValues.length <= 0){
                return false;
            }
            for(i in typeSelectValues){
                var value = typeSelectValues[i];
                if($.inArray(value,availableTypeSelectForMoreOptions) != -1){
                    return true;
                }
            }
            return false;
        };

        var handleMoreOptionsNotAvailable = function(){
            var message = null;

            var typeSelectValues = $(plugin.settings.typeSelectSelector).val();
            if(!typeSelectValues || typeSelectValues.length <= 0){
                message = 'Veuillez saisir un ou plusieurs types de bien';
            }else{
                var valueNotAvailable = isOneValueIsNotAvailable(typeSelectValues);
                if(valueNotAvailable !== null){
                    message = "Le type de bien '"+valueNotAvailable+"' ne possède pas d'options supplémentaires";
                }
            }

            if(message){
                showError(message);
                return true;
            }else{
                clearErrorMessage();
                return false;
            }
        };


        var isOneValueIsNotAvailable = function(values){
            for(i in values){
                var value = values[i];
                if($.inArray(value,availableTypeSelectForMoreOptions) != -1){
                }else{
                    return value;
                }
            }
            return null;
        };

        var handleMoreOptions = function(){
            var btn = $(plugin.settings.moreOptionsBtnSelector);

            clearErrorMessage();


            switchAdvancedFilters($(plugin.settings.typeSelectSelector).val());

            if(btn.hasClass('activated')){
                $(plugin.settings.advancedOptionsContainerSelector).show("fast");
                //cacher le bouton du haut
                $('button.first').closest().hide();
            }else{
                $(plugin.settings.advancedOptionsContainerSelector).hide("fast");
                $(
                    plugin.settings.advancedOptionsInputSelector,
                    plugin.settings.advancedOptionsContainerSelector
                )
                .hide("slow");
                //afficher le bouton du haut
                $('button.first').closest().show();
            }
        };

        var switchAdvancedFilters = function(types) {
            var typeClasses = _.map(types,function(type) { return '.type-' + type}).join('');
            // show all groups of this type
            $(
                plugin.settings.advancedOptionsInputSelector + typeClasses,
                $element
            )
            .show();

            // hide all groups not of this type
            $(
                plugin.settings.advancedOptionsInputSelector,
                $element
            )
            .not(typeClasses)
            .hide();
        };

        var onChangeTypeTransaction = function () {
            if($(plugin.settings.typeTransactionSelector).is('select')){
                var typeTransaction = $(plugin.settings.typeTransactionSelector).val();
                if(typeTransaction === 'buy') {
                    // User selected "Acheter"
                    // make sure there is an option with value="immeuble"
                    var immeubleOption = $("option[value='immeuble']",plugin.settings.typeSelectSelector);
                    if(immeubleOption.length <= 0){
                        $(plugin.settings.typeSelectSelector).append('<option value="immeuble">Immeuble</option>');
                    }

                    // show all buy-only fields
                    $('.buy-only').parent().show();
                }
                else {
                    // User selected "Louer"
                    // remove option with value="immeuble"
                    $("option[value='immeuble']",plugin.settings.typeSelectSelector).remove();

                    // hide all buy-only fields
                    $('.buy-only').parent().hide();
                }

                //reset warning message
                clearErrorMessage();

                $(plugin.settings.typeSelectSelector).trigger('change');
            }

        };

        var showError = function($error){
            clearErrorMessage();
            $(plugin.settings.alertContainerSelector).html($error).show();

        }

        var clearErrorMessage = function(){
            $(plugin.settings.alertContainerSelector).html('').hide();
        };

        var onChangeTypeSelect = function(){
            var btn = $(plugin.settings.moreOptionsBtnSelector);
            if(btn.hasClass('activated')){
                handleMoreOptions();
                if(!isMoreOptionsAvailable()){
                    btn.trigger('click');
                }
            }
        };

        // fire up the plugin!
        // call the "constructor" method
        plugin.init();
    }

     // add the plugin to the jQuery.fn object
     $.fn.PropertyFormSearch = function(options) {

        // iterate through the DOM elements we are attaching the plugin to
        return this.each(function() {

            // if plugin has not already been attached to the element
            if (undefined == $(this).data('PropertyFormSearch') && $(this).is('form')) {

                // create a new instance of the plugin
                // pass the DOM element and the user-provided options as arguments
                var plugin = new $.PropertyFormSearch(this, options);

                // in the jQuery version of the element
                // store a reference to the plugin object
                // you can later access the plugin and its methods and properties like
                // element.data('PropertyFormSearch').publicMethod(arg1, arg2, ... argn) or
                // element.data('PropertyFormSearch').settings.propertyName
                $(this).data('PropertyFormSearch', plugin);
           }
        });

    }

})(jQuery);

// on pourra ajouter un reload de la page (le code initialement l.5 de search.js) si $("#location") est absent du dom, ex :
$(window).bind("pageshow", function(event) {
  if (event.originalEvent.persisted) { // On provient d'un "retour en arriere"
    if(!$("#location").length){
    	// Le select est vide (bouton "previous") on reload la page (pour lire le cookie)
    	window.location.reload()
    }
  }
});
